export default __webpack_public_path__ + "static/media/openaire-8.2017f491.jpg";